import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="hide-on-print tw-mt-20 tw-bg-[#1e1e1e] tw-text-white tw-py-8 md:-tw-mx-32 -tw-mx-3  tw-items-center">
    <div className="tw-container tw-mx-auto tw-px-4">
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-space-x-10 tw-space-y-10 md:tw-space-y-0">
        {/* Company Information */}
        <div className="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0 tw-flex tw-flex-col tw-space-y-4 tw-items-center md:tw-items-start">
          <div className="">
            <Link to="/" aria-label="Home">
              <img
                src="/elogo.png" // Replace with your actual logo path
                alt="Logo"
                className="tw-w-[200px] md:tw-w-[200px] md:tw-h-auto"
              />
            </Link>
          </div>
          {/* <h3 className="tw-text-lg tw-font-semibold">SIPP Americas LLC</h3> */}
          <p className="tw-mt-2 tw-text-sm tw-text-center md:tw-text-left">
            SIPP Americas LLC is a leading applicator of specialized Polyurea
            Protective Industrial Coatings throughout the United States and
            Mexico.
          </p>
          <p className="tw-mt-2 tw-text-sm tw-text-center md:tw-text-left">
            Focusing on the needs and priorities of our customers, Induracoat
            offers industry leading “Green” solutions through its Polyurea spray
            coating systems.
          </p>
        </div>

        <div className="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0 tw-flex tw-flex-col tw-items-center md:tw-items-start">
          <h3 className="tw-text-lg tw-font-semibold">Case Studies</h3>
          <p className="tw-mt-2 tw-text-center md:tw-text-left tw-text-sm">
            Coming Soon
          </p>
        </div>

        <div className="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0 tw-flex tw-flex-col tw-items-center md:tw-items-start">
          <h3 className="tw-text-lg tw-font-semibold">Resiline 320</h3>
          <ul className="tw-mt-2 tw-text-center md:tw-text-left tw-flex tw-flex-col tw-space-y-4">
            <Link to="https://www.sippamericas.com/sipp-lining-equipment/resiline-320/">
              <li className="tw-text-[#00B5ED] hover:tw-text-[#ffffff] tw-text-sm">
                About Resiline 320
              </li>
            </Link>

            <Link to="https://www.sippamericas.com/sipp-lining-equipment/">
              <li className="tw-text-[#00B5ED] hover:tw-text-[#ffffff] tw-text-sm">
                SIPP Lining Process
              </li>
            </Link>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0 tw-flex tw-flex-col tw-items-center md:tw-items-start">
          <h3 className="tw-text-lg tw-font-semibold">Contact Us</h3>
          <div className="tw-flex tw-flex-col tw-items-center md:tw-items-start tw-space-y-6">
            <p className="tw-mt-2 tw-text-center md:tw-text-left tw-text-sm">
              Email:{" "}
              <a
                href="mailto:info@sippamericas.com"
                className="tw-text-white hover:tw-text-[#00B5ED]"
              >
                contact@sippamericas.com
              </a>
            </p>

            <div className="tw-bg-[#00B5ED] hover:tw-bg-[#ffffff] tw-p-1 tw-rounded-md">
              <Link
                to="https://www.linkedin.com/posts/sipp-americas-llc_sipp-linings-must-be-looked-at-as-a-complete-activity-7259650578513854464-uEwx?utm_source=share&utm_medium=member_desktop"
                target="_blank"
              >
                <img
                  src="/linkedin.png"
                  alt="Linkedin Logo"
                  className="tw-h-6 tw-w-6"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="tw-border-b-2 tw-w-full tw-my-10 tw-border-gray-600"></div>

      <div className="tw-flex md:tw-flex-row tw-flex-col tw-items-center tw-justify-between tw-space-y-4 md:tw-space-y-0">
        <Link
          to="https://resiline.co.uk/"
          target="_blank"
          className="tw-order-1 md:tw-order-2"
        >
          <div>
            <img src="https://www.sippamericas.com/wp-content/uploads/2021/02/resiline-logo.png" alt="resiline" className=" tw-w-32" />
            <p className="tw-text-[6px] tw-pl-16">Authorized Applicator</p>
          </div>
        </Link>
        <p className="tw-order-2 md:tw-order-1 tw-text-sm">
          © SIPP Americas LLC 2024
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
